export default __webpack_public_path__ + "media/images/react_icons/chain_link-52076c881c61d8fe4dfeb5211d643794.svg";